<template>
  <div style="height: 400px;">
    <div
      style="line-height: 100px;font-size: 60px;color: #666;margin-top: 100px;text-align: center;"
    >
      <i :class="showicon"></i>
    </div>
    <div style="line-height: 100px;font-size: 40px;color: #666;text-align: center;">
      {{ showdata }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmptyView',
  props: {
    showdata: {
      type: String,
      default: '数据有误,请稍后重试'
    },
    showicon: {
      type: String,
      default: 'el-icon-lightning'
    },
  }
}
</script>